<template>
	<main class="service-institution-pc" :lang="pageLang">
		<InstitutionDemo />

		<div class="institution-join-header">
			<div class="pc-center-1200">
				<div class="design-title">
					<div class="design-title-heading">
						<img
							class="design-title-decor design-title-decor--left"
							:src="titleDecorImage"
							alt=""
						/>
						<h2>{{ t(`${SI_I18N_NS}.joinHeader.title`) }}</h2>
						<img class="design-title-decor" :src="titleDecorImage" alt="" />
					</div>
					<p>{{ t(`${SI_I18N_NS}.joinHeader.subtitle`) }}</p>
				</div>
			</div>
		</div>

		<div class="banner-container" :class="{ 'banner-container--en': pageLang === 'en' }">
			<div class="banner-glow-wrap">
				<div class="bg-circle" :style="{ backgroundImage: `url(${bannerGlowImage})` }"></div>
			</div>
			<div class="pc-center-1200">
				<div class="banner-content">
					<div class="banner-left">
						<div class="left-title">
							{{ t("corporateCenter.indexPc.banner.titleLine1") }}
							<br />
							{{ t("corporateCenter.indexPc.banner.titleLine2") }}
						</div>
						<div class="left-content">{{ t("corporateCenter.indexPc.banner.body") }}</div>

						<div class="left-operate">
							<div class="join-btn" @click="handleJoinEntryClick">
								{{ t("corporateCenter.indexPc.banner.joinCta") }}
							</div>
							<div class="contact-btn" @click="handleContactCoopClick('hero')">
								{{ t("corporateCenter.indexPc.banner.contactCta") }}
							</div>
						</div>
					</div>
					<div class="banner-right">
						<img :src="bannerHeroImage" :alt="t('corporateCenter.indexPc.banner.heroImageAlt')" />
					</div>
				</div>
			</div>
		</div>

		<div class="section1-wrap">
			<div class="pc-center-1200">
				<div
					ref="solutionSectionRef"
					class="section1"
					:class="{ 'section1--en': pageLang === 'en' }"
				>
					<div class="section-design-title">
						<img
							class="design-title-decor design-title-decor--left"
							:src="titleDecorImage"
							alt=""
						/>
						<h2
							class="section-design-title-text"
							:class="{ 'section-design-title-text--preline': pageLang === 'en' }"
						>
							{{ section1TitleDisplay }}
						</h2>
						<img class="design-title-decor" :src="titleDecorImage" alt="" />
					</div>
					<div class="section1-content">
						<div class="section-card">
							<div class="card-title">
								{{ t("corporateCenter.indexPc.section1.challengeColumnTitle") }}
							</div>
							<div v-for="item in challengeList" :key="item.title" class="card-item">
								<img :src="item.icon" :alt="item.title" />
								<div class="item-text">
									<div class="item-title">{{ item.title }}</div>
									<div class="item-desc">{{ item.desc }}</div>
								</div>
							</div>
						</div>

						<div class="section-card">
							<div class="card-title">
								{{ t("corporateCenter.indexPc.section1.solutionColumnTitle") }}
							</div>
							<div v-for="item in solutionList" :key="item.title" class="card-item">
								<img :src="item.icon" :alt="item.title" />
								<div class="item-text">
									<div class="item-title">{{ item.title }}</div>
									<div class="item-desc">{{ item.desc }}</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="section2-wrap">
			<div class="pc-center-1200">
				<div class="section2" :class="{ 'section2--en': pageLang === 'en' }">
					<div class="section2-left">
						<div class="map-markers">
							<div
								v-for="m in section2MapMarkers"
								:key="m.markerClass"
								class="map-marker"
								:class="m.markerClass"
							>
								<span>{{ m.label }}</span>
								<strong>{{ m.percent }}</strong>
							</div>
						</div>
						<div class="map-box">
							<img :src="mapImage" :alt="t('corporateCenter.indexPc.section2.mapImageAlt')" />
						</div>
					</div>

					<div class="section2-right">
						<div class="section2-title">
							{{ t("corporateCenter.indexPc.section2.sectionTitle") }}
						</div>
						<div class="section2-desc">{{ t("corporateCenter.indexPc.section2.sectionDesc") }}</div>
						<div ref="metricListRef" class="metric-list">
							<div v-for="item in metricList" :key="item.text" class="metric-item">
								<img :src="item.icon" :alt="item.text" />
								<span>{{ item.text }}</span>
								<b>{{ item.value }}</b>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="section3-wrap">
			<div class="pc-center-1200">
				<div class="section3" :class="{ 'section3--en': pageLang === 'en' }">
					<div class="section-design-title section3-design-title">
						<img
							class="design-title-decor design-title-decor--left"
							:src="titleDecorImage"
							alt=""
						/>
						<h2 class="section-design-title-text">
							{{ t("corporateCenter.indexPc.section3.sectionTitle") }}
						</h2>
						<img class="design-title-decor" :src="titleDecorImage" alt="" />
					</div>
					<div class="section3-body">
						<div class="section3-labels">
							<div class="row-label">{{ t("corporateCenter.indexPc.section3.rowLabelTop") }}</div>
							<div class="row-label">
								{{ t("corporateCenter.indexPc.section3.rowLabelBottom") }}
							</div>
						</div>
						<div class="section3-grid-wrap">
							<div class="section3-grid">
								<div v-for="item in section3TopList" :key="item.title" class="value-card">
									<img :src="item.icon" :alt="item.title" class="value-icon" />
									<div class="value-title">{{ item.title }}</div>
									<div class="value-desc">{{ item.desc }}</div>
								</div>
							</div>
							<div class="section3-grid">
								<div v-for="item in section3BottomList" :key="item.title" class="value-card">
									<img :src="item.icon" :alt="item.title" class="value-icon" />
									<div class="value-title">{{ item.title }}</div>
									<div class="value-desc">{{ item.desc }}</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="join-section-wrap" :class="{ 'join-section-wrap--en': pageLang === 'en' }">
			<div class="pc-center-1200">
				<div class="join-section">
					<div class="section-design-title join-design-title">
						<img
							class="design-title-decor design-title-decor--left"
							:src="titleDecorImage"
							alt=""
						/>
						<h2 class="section-design-title-text">
							{{ t("corporateCenter.indexPc.join.sectionTitle") }}
						</h2>
						<img class="design-title-decor" :src="titleDecorImage" alt="" />
					</div>
					<div ref="joinFlowRef" class="join-flow">
						<div class="join-center">
							<img
								:src="joinCenterImageSrc"
								:alt="t('corporateCenter.indexPc.join.centerImageAlt')"
							/>
						</div>
						<div
							v-for="(step, index) in joinProcessSteps"
							:key="step.title"
							class="join-step"
							:class="[`join-step--${index + 1}`, { 'join-step--revealed': joinStepsRevealed }]"
						>
							<img :src="step.icon" :alt="step.label" class="join-step-ball" />
							<div class="join-step-title">{{ step.title }}</div>
							<p class="join-step-desc">{{ step.desc }}</p>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="section4-wrap">
			<div class="pc-center-1200">
				<div class="section4" :class="{ 'section4--en': pageLang === 'en' }">
					<div class="section-design-title section4-design-title">
						<img
							class="design-title-decor design-title-decor--left"
							:src="titleDecorImage"
							alt=""
						/>
						<h2 class="section-design-title-text">
							{{ t("corporateCenter.indexPc.section4.title") }}
						</h2>
						<img class="design-title-decor" :src="titleDecorImage" alt="" />
					</div>
					<div class="section4-content">
						<div class="section4-desc">{{ t("corporateCenter.indexPc.section4.desc") }}</div>
						<div class="section4-phones">
							<img class="section4-float" :src="section4FloatImage" alt="" />
							<img
								class="section4-phone"
								:src="section4Phone1"
								:alt="t('corporateCenter.indexPc.section4.imageAlt')"
							/>
							<img
								class="section4-phone"
								:src="section4Phone2"
								:alt="t('corporateCenter.indexPc.section4.imageAlt')"
							/>
							<img
								class="section4-phone"
								:src="section4Phone3"
								:alt="t('corporateCenter.indexPc.section4.imageAlt')"
							/>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="section5-wrap">
			<div class="pc-center-1200">
				<div class="section5" :class="{ 'section5--en': pageLang === 'en' }">
					<div class="section5-content">
						<div class="section5-gradient-layer"></div>
						<div
							class="section5-image-layer"
							:style="{ backgroundImage: `url(${section5HeroImage})` }"
						></div>
						<div class="section5-left">
							<div class="section5-title">{{ t("corporateCenter.indexPc.section5.title") }}</div>
							<div class="section5-desc">{{ t("corporateCenter.indexPc.section5.desc") }}</div>
							<div class="section5-btn" @click="handleSection5KfClick">
								{{ t("corporateCenter.indexPc.section5.btn") }}
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<n-modal
			v-model:show="showContactCoopModal"
			:mask-closable="true"
			:closable="false"
			class="cc-contact-coop-modal"
		>
			<div class="cc-contact-coop-panel">
				<button
					type="button"
					class="cc-contact-coop-close"
					:aria-label="t(`${I18N_NS}.banner.contactCoopModal.closeAria`)"
					@click="showContactCoopModal = false"
				>
					<img :src="closeIcon" alt="" />
				</button>
				<h3 class="cc-contact-coop-title">{{ t(`${I18N_NS}.banner.contactCoopModal.title`) }}</h3>
				<p class="cc-contact-coop-body">{{ t(`${I18N_NS}.banner.contactCoopModal.body`) }}</p>
				<a
					class="cc-contact-coop-cta"
					:href="`mailto:${CONTACT_COOP_EMAIL}`"
					rel="noopener noreferrer"
					@click="trackOnboardingCta('email_contact', 'contact_modal', contactCoopCtaLabel)"
				>
					{{ contactCoopCtaLabel }}
				</a>
			</div>
		</n-modal>

		<CorporateCenterLoginModal v-model="showLoginModal" />
	</main>
</template>

<script setup>
import { computed, onBeforeUnmount, ref } from "vue";
import { NModal } from "naive-ui";
import { useIntersectionObserver } from "@vueuse/core";
import { useI18n } from "~/composables/useI18n";
import CorporateCenterLoginModal from "@variants/seer/corporate-center/index/pc/components/corporate-center-login-modal.vue";
import InstitutionDemo from "./components/institution-demo/index.vue";
import { useServiceInstitutionTracking } from "./composables/useServiceInstitutionTracking";
import { navigateCorporateCenterPage } from "~/utils/corporate-center-route";
import closeIcon from "~/components/pc/login/images/close.png";
import titleDecorImage from "./image/title-decor.svg";
import section4Phone1 from "./image/section4-phone-1.png";
import section4Phone2 from "./image/section4-phone-2.png";
import section4Phone3 from "./image/section4-phone-3.png";
import section4FloatImage from "./image/section4-float.png";
import section1_1 from "~/pages/seer/corporate-center/index/pc/image/section1_1.png";
import section1_2 from "~/pages/seer/corporate-center/index/pc/image/section1_2.png";
import section1_3 from "~/pages/seer/corporate-center/index/pc/image/section1_3.png";
import section1_4 from "~/pages/seer/corporate-center/index/pc/image/section1_4.png";
import section1_5 from "~/pages/seer/corporate-center/index/pc/image/section1_5.png";
import section1_6 from "~/pages/seer/corporate-center/index/pc/image/section1_6.png";
import section1_7 from "~/pages/seer/corporate-center/index/pc/image/section1_7.png";
import section1_8 from "~/pages/seer/corporate-center/index/pc/image/section1_8.png";
import section1_9 from "~/pages/seer/corporate-center/index/pc/image/section1_9.png";
import section1_10 from "~/pages/seer/corporate-center/index/pc/image/section1_10.png";
import section1_11 from "~/pages/seer/corporate-center/index/pc/image/section1_11.png";
import mapImage from "~/pages/seer/corporate-center/index/pc/image/map.png";
import section3_1 from "~/pages/seer/corporate-center/index/pc/image/section3_1.png";
import section3_2 from "~/pages/seer/corporate-center/index/pc/image/section3_2.png";
import section3_3 from "~/pages/seer/corporate-center/index/pc/image/section3_3.png";
import section3_4 from "~/pages/seer/corporate-center/index/pc/image/section3_4.png";
import section3_5 from "~/pages/seer/corporate-center/index/pc/image/section3_5.png";
import section3_6 from "~/pages/seer/corporate-center/index/pc/image/section3_6.png";
import section5Image from "~/pages/seer/corporate-center/index/pc/image/section5.png";
import section5ImageEn from "~/pages/seer/corporate-center/index/pc/image/section5_en.png";
import joinStep1 from "~/pages/seer/corporate-center/index/pc/image/step1.png";
import joinStep2 from "~/pages/seer/corporate-center/index/pc/image/step2.png";
import joinStep3 from "~/pages/seer/corporate-center/index/pc/image/step3.png";
import joinStep4 from "~/pages/seer/corporate-center/index/pc/image/step4.png";
import joinCenterImage from "~/pages/seer/corporate-center/index/pc/image/center.png";
import joinCenterImageEn from "~/pages/seer/corporate-center/index/pc/image/center_en.png";
import bannerHeroZh from "~/pages/seer/corporate-center/index/pc/image/desc_pic.png";
import bannerHeroEn from "~/pages/seer/corporate-center/index/pc/image/banner_en.png";
import bannerGlowImage from "./image/banner-glow.png";

const I18N_NS = "corporateCenter.indexPc";
const SI_I18N_NS = "serviceInstitution.pc";

const { t, locale } = useI18n();
const { track } = useServiceInstitutionTracking("pc");

const pageLang = computed(() => (locale?.value === "en" ? "en" : "zh-TW"));

const section1TitleDisplay = computed(() => {
	const text = t(`${I18N_NS}.section1.sectionTitle`);
	if (locale?.value !== "en") return text;
	return text
		.split(",")
		.map(s => s.trim())
		.filter(Boolean)
		.join("\n");
});

const section5HeroImage = computed(() =>
	locale?.value === "en" ? section5ImageEn : section5Image
);

const joinCenterImageSrc = computed(() =>
	locale?.value === "en" ? joinCenterImageEn : joinCenterImage
);

const bannerHeroImage = computed(() => (locale?.value === "en" ? bannerHeroEn : bannerHeroZh));

const showLoginModal = ref(false);
const showContactCoopModal = ref(false);
const solutionSectionRef = ref(null);

const CONTACT_COOP_EMAIL = "tarry@seeronnet.com";
const contactCoopCtaLabel = computed(() =>
	t(`${I18N_NS}.banner.contactCoopModal.cta`, { email: CONTACT_COOP_EMAIL })
);

const handleJoinEntryClick = () => {
	trackOnboardingCta("join_now", "hero", t("corporateCenter.indexPc.banner.joinCta"));
	if (import.meta.client && localStorage.getItem("token")) {
		navigateCorporateCenterPage("/seer/corporate-center/join");
		return;
	}
	showLoginModal.value = true;
};

const trackOnboardingCta = (ctaId, pagePosition, ctaName = ctaId) => {
	track("institution_onboarding_cta_click", {
		cta_id: ctaId,
		cta_name: typeof ctaName === "object" && "value" in ctaName ? ctaName.value : ctaName,
		section_id: "institution_entry",
		page_position: pagePosition,
	});
};

const handleContactCoopClick = pagePosition => {
	trackOnboardingCta("contact_us", pagePosition, t("corporateCenter.indexPc.banner.contactCta"));
	showContactCoopModal.value = true;
};

const challengeIcons = [section1_1, section1_2, section1_3];
const solutionIcons = [section1_4, section1_5, section1_6];

const challengeList = computed(() =>
	challengeIcons.map((icon, i) => ({
		icon,
		title: t(`${I18N_NS}.section1.challenge.${i}.title`),
		desc: t(`${I18N_NS}.section1.challenge.${i}.desc`),
	}))
);

const solutionList = computed(() =>
	solutionIcons.map((icon, i) => ({
		icon,
		title: t(`${I18N_NS}.section1.solution.${i}.title`),
		desc: t(`${I18N_NS}.section1.solution.${i}.desc`),
	}))
);

const { stop: stopSolutionSectionObserver } = useIntersectionObserver(
	solutionSectionRef,
	([entry]) => {
		if (!entry?.isIntersecting) return;
		track("institution_solution_section_view", {
			section_id: "solution_challenge",
			card_count: challengeList.value.length + solutionList.value.length,
		});
		stopSolutionSectionObserver();
	},
	{ threshold: 0.25, rootMargin: "0px 0px -8% 0px" }
);

const metricIcons = [section1_7, section1_8, section1_9, section1_10, section1_11];
const metricValues = [">426k", ">3786k", ">174k", ">796k", ">200"];

function parseMetricDisplay(s) {
	const m = String(s).match(/^>(\d+)(.*)$/);
	if (!m) return { target: 0, suffix: "" };
	return { target: Number(m[1]), suffix: m[2] };
}

const metricSpecs = metricValues.map(parseMetricDisplay);
const metricDisplayValues = ref(metricSpecs.map(({ suffix }) => `>0${suffix}`));

const metricList = computed(() =>
	metricIcons.map((icon, i) => ({
		icon,
		value: metricDisplayValues.value[i] ?? metricValues[i],
		text: t(`${I18N_NS}.section2.metric.${i}.text`),
	}))
);

const metricListRef = ref(null);
const metricAnimStarted = ref(false);
let metricAnimRaf = 0;

function runMetricCountUp() {
	if (!import.meta.client || metricAnimStarted.value) return;
	metricAnimStarted.value = true;
	const duration = 1400;
	const start = performance.now();
	const easeOutCubic = t => 1 - (1 - t) ** 3;

	const tick = now => {
		const progress = Math.min(1, (now - start) / duration);
		const e = easeOutCubic(progress);
		metricDisplayValues.value = metricSpecs.map(({ target, suffix }) => {
			const v = Math.round(target * e);
			return `>${v}${suffix}`;
		});
		if (progress < 1) {
			metricAnimRaf = requestAnimationFrame(tick);
		} else {
			metricDisplayValues.value = [...metricValues];
			metricAnimRaf = 0;
		}
	};
	metricAnimRaf = requestAnimationFrame(tick);
}

const { stop: stopMetricObserver } = useIntersectionObserver(
	metricListRef,
	([entry]) => {
		if (!entry?.isIntersecting || metricAnimStarted.value) return;
		runMetricCountUp();
		stopMetricObserver();
	},
	{ threshold: 0.2, rootMargin: "0px 0px -8% 0px" }
);

const section2MarkerLayout = [
	{ markerClass: "marker-north-america", percent: "15%" },
	{ markerClass: "marker-others", percent: "25%" },
	{ markerClass: "marker-southeast-asia", percent: "50%" },
	{ markerClass: "marker-japan-korea", percent: "10%" },
];

const section2MapMarkers = computed(() =>
	section2MarkerLayout.map((row, i) => ({
		...row,
		label: t(`${I18N_NS}.section2.marker.${i}.label`),
	}))
);

const section3TopIcons = [section3_1, section3_2, section3_3];
const section3BottomIcons = [section3_4, section3_5, section3_6];

const section3TopList = computed(() =>
	section3TopIcons.map((icon, i) => ({
		icon,
		title: t(`${I18N_NS}.section3.top.${i}.title`),
		desc: t(`${I18N_NS}.section3.top.${i}.desc`),
	}))
);

const section3BottomList = computed(() =>
	section3BottomIcons.map((icon, i) => ({
		icon,
		title: t(`${I18N_NS}.section3.bottom.${i}.title`),
		desc: t(`${I18N_NS}.section3.bottom.${i}.desc`),
	}))
);

const joinStepIcons = [joinStep1, joinStep2, joinStep3, joinStep4];

const joinProcessSteps = computed(() =>
	joinStepIcons.map((icon, i) => ({
		icon,
		label: `0${i + 1}`,
		title: t(`${I18N_NS}.join.step${i + 1}.title`),
		desc: t(`${I18N_NS}.join.step${i + 1}.desc`),
	}))
);

const joinFlowRef = ref(null);
const joinStepsRevealed = ref(false);

const CORPORATE_SECTION5_KF_URL = "https://kf.seerq.io/?scene=11570000&lng=tc&channel=seer_6sco";

const handleSection5KfClick = () => {
	if (!import.meta.client) return;
	trackOnboardingCta(
		"customer_service_consult",
		"bottom_cta",
		t("corporateCenter.indexPc.section5.btn")
	);
	window.open(CORPORATE_SECTION5_KF_URL, "_blank", "noopener,noreferrer");
};

const { stop: stopJoinFlowObserver } = useIntersectionObserver(
	joinFlowRef,
	([entry]) => {
		if (!entry?.isIntersecting || joinStepsRevealed.value) return;
		joinStepsRevealed.value = true;
		stopJoinFlowObserver();
	},
	{ threshold: 0.18, rootMargin: "0px 0px -8% 0px" }
);

onBeforeUnmount(() => {
	if (metricAnimRaf) cancelAnimationFrame(metricAnimRaf);
	stopMetricObserver();
	stopSolutionSectionObserver();
});
</script>

<style lang="scss" scoped>
@use "@variants/seer/styles/pc-button-hover" as btn;

.service-institution-pc {
	min-height: 100vh;
	background: #fff;
	color: #2f2d2c;

	-webkit-hyphens: auto;
	hyphens: auto;
	/* 装饰图/负定位不撑出横向滚动条，避免与廣場页切换时左右抖动 */
	overflow-x: clip;
}

.service-institution-pc[lang="en"] {
}

.service-institution-pc,
.service-institution-pc :deep(*) {
	word-break: normal !important;
	overflow-wrap: normal !important;
	word-wrap: normal !important;
}

.service-institution-pc[lang="en"],
.service-institution-pc[lang="en"] :deep(*) {
	-webkit-hyphens: auto;
	hyphens: auto;
	overflow-wrap: anywhere !important;
	word-wrap: break-word !important;
}

.service-institution-pc :deep(.pc-center-1200) {
	width: min(1200px, calc(100% - 48px));
	max-width: none;
	padding-right: 0;
	padding-left: 0;
}

.institution-join-header {
	background: #ffffff;
}

.design-title {
	padding: 62px 0 44px;
	text-align: center;
}

.design-title-heading {
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 16px;
}

.design-title-decor {
	width: 120px;
	height: 16px;
	flex-shrink: 0;
}

.design-title-decor--left {
	transform: rotate(180deg) scaleY(-1);
}

.design-title h2 {
	margin: 0;
	color: #333;

	font-size: 42px;
	font-weight: 800;
	line-height: normal;
	white-space: nowrap;
}

.design-title p {
	margin: 0 auto;
	padding-top: 12px;
	max-width: 896px;
	color: #333;

	font-size: 32px;
	font-weight: 500;
	line-height: normal;
	text-align: center;
}

.section-design-title {
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 16px;
	margin-bottom: 48px;
}

.section-design-title-text {
	margin: 0;
	color: #333;

	font-size: 42px;
	font-weight: 800;
	line-height: normal;
	white-space: nowrap;
	text-align: center;

	&--preline {
		white-space: pre-line;
		line-height: 1.5;
	}
}

.service-institution-pc[lang="en"] {
	.design-title-heading {
		flex-wrap: wrap;
	}

	.section-design-title {
		flex-wrap: nowrap;
	}

	.design-title h2,
	.section-design-title-text {
		max-width: min(100%, 920px);
		min-width: 0;
		white-space: normal;
		line-height: 1.22;
	}

	.section-design-title-text--preline {
		white-space: pre-line;
		line-height: 1.5;
	}

	.design-title p {
		font-size: 26px;
		line-height: 1.38;
	}
}

.banner-container {
	width: 100%;
	margin: 0 auto;
	min-height: 600px;
	background-color: #fffdf9;
	background-image: linear-gradient(0deg, #fffbf3, #ffffff);
	position: relative;
	overflow: hidden;

	&.banner-container--en {
		min-height: 630px;

		.banner-glow-wrap {
			height: 630px;
		}

		.left-title {
			max-width: 560px;
			padding-right: 0;
			font-size: 30px !important;
			line-height: 40px !important;
		}

		.banner-content {
			min-height: 630px;
			height: auto !important;
			padding: 56px 0;
		}

		.banner-left {
			height: auto !important;
			min-width: 0;
		}

		.left-content {
			width: 100% !important;
			max-width: 609px;
		}

		.left-operate {
			flex-wrap: wrap;
			margin-top: 48px !important;
		}
	}

	.banner-content {
		width: 100%;
		height: 600px;
		display: flex;
		align-items: center;

		.banner-left {
			flex: 1;
			height: 484px;

			.left-title {
				font-weight: bold;
				font-size: 36px;
				color: #333333;
				line-height: 54px;
			}

			.left-content {
				margin-top: 45px;
				width: 609px;
				font-weight: 400;
				font-size: 20px;
				color: #333333;
				line-height: 28px;
				white-space: pre-line;
				position: relative;
				z-index: 9;
			}

			.left-operate {
				display: flex;
				gap: 23px;
				margin-top: 70px;

				.contact-btn {
					display: inline-flex;
					align-items: center;
					justify-content: center;
					width: 232px;
					min-height: 48px;
					padding: 8px 18px;
					background: #ffffff;
					border-radius: 8px;
					border: 1px solid #dfdfdf;
					box-sizing: border-box;
					text-align: center;
					line-height: 1.2;
					font-weight: 400;
					font-size: 20px;
					color: #595959;
					cursor: pointer;

					@include btn.ghost-hover;
				}

				.join-btn {
					display: inline-flex;
					align-items: center;
					justify-content: center;
					width: 232px;
					min-height: 48px;
					padding: 8px 18px;
					background: #333333;
					border-radius: 8px;
					box-sizing: border-box;
					text-align: center;
					line-height: 1.2;
					font-weight: 400;
					font-size: 20px;
					color: #ffffff;
					cursor: pointer;

					@include btn.dark-hover;
				}
			}
		}

		.banner-right {
			width: 510px;
			height: 484px;
			position: relative;
			z-index: 9;

			img {
				width: 488px;
				height: 484px;
				display: block;
				transition: transform 0.45s ease;
				transform-origin: center center;

				&:hover {
					transform: scale(1.05);
				}
			}
		}
	}

	.banner-glow-wrap {
		position: absolute;
		top: 0;
		right: 0;
		width: 915px;
		max-width: 47.66%;
		height: 600px;
		pointer-events: none;
		-webkit-mask-image: linear-gradient(180deg, rgba(255, 251, 243, 0) 0%, #fff 36.17%);
		mask-image: linear-gradient(180deg, rgba(255, 251, 243, 0) 0%, #fff 36.17%);
	}

	.bg-circle {
		position: absolute;
		top: 0;
		right: 0;
		width: 770px;
		height: 511px;
		background-repeat: no-repeat;
		background-size: 100% 100%;
	}
}

.cc-contact-coop-modal {
	:deep(.n-modal-body-wrapper) {
		padding: 0;
	}
}

.cc-contact-coop-panel {
	position: relative;
	box-sizing: border-box;
	width: 520px;
	max-width: calc(100vw - 48px);
	padding: 40px 36px 36px;
	border-radius: 12px;
	background: #f5f5f6;
	text-align: left;
}

.cc-contact-coop-close {
	position: absolute;
	top: 12px;
	right: 12px;
	display: flex;
	align-items: center;
	justify-content: center;
	width: 36px;
	height: 36px;
	padding: 0;
	border: none;
	background: transparent;
	cursor: pointer;

	img {
		display: block;
		width: 24px;
		height: 24px;
	}
}

.cc-contact-coop-title {
	margin: 0 0 16px;
	padding-right: 32px;
	font-size: 22px;
	font-weight: 700;
	color: #333333;
	line-height: 1.35;
}

.cc-contact-coop-body {
	margin: 0 0 28px;
	font-size: 15px;
	line-height: 1.65;
	color: #666666;
}

.cc-contact-coop-cta {
	display: inline-flex;
	align-items: center;
	justify-content: center;
	min-height: 48px;
	padding: 0 22px;
	border-radius: 8px;
	background: #111111;
	font-size: 16px;
	font-weight: 600;
	color: #ffffff;
	text-decoration: none;
	cursor: pointer;

	@include btn.dark-hover;

	&:hover {
		color: #ffffff;
	}
}

.section1 {
	padding: 78px 0 48px;

	&.section1--en {
		.section-design-title-text--preline {
			font-size: 30px !important;
		}

		.section-card {
			height: auto !important;
			min-height: 747px;
			align-self: stretch;
		}

		.card-item {
			height: auto !important;
			min-height: 200px;
			padding: 28px 0 !important;
			align-items: flex-start !important;

			img {
				margin-top: 4px;
				height: 80px !important;
				width: 80px !important;
			}

			.item-title {
				font-size: 22px !important;
				line-height: 26px !important;
				margin-bottom: 10px;
				color: #333333;
				font-weight: bold;
			}

			.item-desc {
				font-size: 18px !important;
				color: #a0a0a0;
				line-height: 26px;
			}
		}
	}

	.section1-content {
		display: flex;
		gap: 20px;
		align-items: stretch;
		justify-content: center;
		width: fit-content;
		max-width: 100%;
		margin: 0 auto;
	}

	.section-card {
		height: 581px;
		width: 588px;
		padding: 18px 20px;
		border-radius: 12px;
		border: 1px solid #dedede;

		.card-title {
			font-weight: bold;
			font-size: 32px;
			color: #333333;
			text-align: center;
			margin-bottom: 24px;
		}

		.card-item {
			display: flex;
			align-items: center;
			gap: 24px;
			padding: 12px 0;
			height: 150px;
			border-top: 1px solid #eeeeee;

			img {
				width: 80px;
				height: 80px;
				flex-shrink: 0;
				transition: transform 0.35s ease;
				transform-origin: center center;

				&:hover {
					transform: scale(1.12);
				}
			}

			.item-text {
				flex: 1;
				min-width: 0;
			}

			.item-title {
				font-size: 25px;
				line-height: 35px;
				color: #333333;
				font-weight: 600;
				margin-bottom: 6px;
			}

			.item-desc {
				font-size: 18px;
				line-height: 26px;
				color: #a0a0a0;
			}
		}
	}
}

.section1-wrap {
	width: 100%;
	margin: 0 auto;
}

.section2-wrap {
	width: 100%;
	margin: 0 auto;
	height: 649px;
	background: linear-gradient(0deg, #fffbf3, #ffffff);
	padding-top: 122px;
}

.section2 {
	display: flex;
	align-items: center;
	justify-content: space-between;
}

.section2.section2--en {
	.section2-right .section2-title {
		font-size: 30px !important;
		line-height: 1.5 !important;

		font-weight: bold;
		color: #333333;
		margin-bottom: 30px !important;
	}

	.section2-desc {
		font-weight: 400;
		font-size: 20px !important;
		color: #333333;
		line-height: 28px !important;
	}

	.section2-right {
		min-width: 0;
	}

	.metric-item {
		align-items: flex-start;
		flex-wrap: wrap;
		font-size: 20px;
		line-height: 1.35;

		span {
			min-width: 0;
			flex: 1 1 320px;
		}

		b {
			margin-top: 3px;
			white-space: nowrap;
		}
	}

	.marker-southeast-asia {
		left: 360px;
		top: 30px;
		--line-height: 172px;
	}

	.marker-japan-korea {
		right: 18px !important;
		top: -50px !important;
	}

	.section2-left .map-markers {
		height: auto;
		min-height: 66px;
	}

	.section2-left .map-marker {
		white-space: normal;
		display: flex;
		flex-direction: column;
		align-items: center;
		text-align: center;
		line-height: 1.2;

		span {
			margin-right: 0;
		}

		strong {
			margin-top: 2px;
		}

		&::before {
			top: 48px;
		}

		&::after {
			top: 40px;
		}
	}
}

.section2-left {
	width: 566px;
	position: relative;

	.map-markers {
		position: relative;
		height: 66px;
	}

	.map-marker {
		position: absolute;
		font-size: 16px;
		color: #333333;
		line-height: 24px;
		white-space: nowrap;
		--marker-color: #7f93e5;
		--line-height: 145px;
		--marker-shadow: rgba(127, 147, 229, 0.42);

		span {
			color: #666666;
			margin-right: 2px;
		}

		&::before {
			content: "";
			position: absolute;
			left: 50%;
			transform: translateX(-50%);
			top: 34px;
			width: 1px;
			height: var(--line-height);
			background: var(--marker-color);
		}

		&::after {
			content: "";
			position: absolute;
			left: 50%;
			transform: translateX(-50%);
			top: 26px;
			width: 8px;
			height: 8px;
			border-radius: 50%;
			background: var(--marker-color);
			animation: markerPulse 1.8s ease-in-out infinite;
			box-shadow: 0 0 0 0 var(--marker-shadow);
		}
	}

	.marker-north-america {
		left: 60px;
		top: 8px;
		--marker-color: #7f93e5;
		--line-height: 154px;
		--marker-shadow: rgba(127, 147, 229, 0.42);
	}

	.marker-others {
		left: 205px;
		top: 6px;
		--marker-color: #f08a8a;
		--line-height: 150px;
		--marker-shadow: rgba(240, 138, 138, 0.42);
	}

	.marker-southeast-asia {
		left: 374px;
		top: 40px;
		--marker-color: #f0b432;
		--line-height: 182px;
		--marker-shadow: rgba(240, 180, 50, 0.42);
		z-index: 99;
	}

	.marker-japan-korea {
		right: 38px;
		top: -40px;
		--marker-color: #b99ce0;
		--line-height: 196px;
		--marker-shadow: rgba(185, 156, 224, 0.42);
		z-index: 98;
	}

	.map-box {
		padding: 18px 10px 16px;

		img {
			width: 558px;
			height: 310px;
			display: block;
		}
	}
}

@keyframes markerPulse {
	0% {
		transform: translateX(-50%) scale(1);
		box-shadow: 0 0 0 0 var(--marker-shadow);
	}
	40% {
		transform: translateX(-50%) scale(1.15);
		box-shadow: 0 0 0 8px rgba(255, 255, 255, 0);
	}
	100% {
		transform: translateX(-50%) scale(1);
		box-shadow: 0 0 0 0 rgba(127, 147, 229, 0);
	}
}

.section2-right {
	width: 600px;
	margin-top: -20px;

	.section2-title {
		font-weight: bold;
		font-size: 36px;
		color: #333333;
		line-height: 54px;
		margin-bottom: 45px;
	}

	.section2-desc {
		font-weight: 400;
		font-size: 20px;
		color: #333333;
		line-height: 28px;
		margin-bottom: 50px;
	}

	.metric-list {
		display: flex;
		flex-direction: column;
		gap: 20px;
	}

	.metric-item {
		display: flex;
		align-items: center;
		font-size: 22px;
		color: #333333;
		line-height: 28px;

		img {
			width: 32px;
			height: 32px;
			margin-right: 12px;
			flex-shrink: 0;
		}

		b {
			color: #f2af19;
			font-weight: 500;
			margin-left: 6px;
			display: inline-flex;
			align-items: center;
			line-height: 1;
			transform: translateY(-1px);
		}
	}
}

.section3-wrap {
	width: 100%;
	margin: 0 auto;
	padding: 88px 0 0px;
}

.section3 {
	&.section3--en {
		.section-design-title-text {
			font-size: 30px;
			line-height: 42px;
		}

		.section3-grid-wrap {
			> .section3-grid:first-child .value-card {
				height: auto !important;
				min-height: 560px !important;
				padding: 24px 18px 14px !important;

				.value-desc {
					padding: 0 6px 0 !important;
				}

				.value-title {
					min-height: 50px !important;
				}
			}
			> .section3-grid:last-child .value-card {
				height: auto !important;
				min-height: 430px !important;
				padding: 68px 24px 14px !important;
			}
		}

		.section3-grid {
			.value-title {
				min-height: 50px !important;

				font-weight: bold;
				font-size: 24px !important;
				color: #333333;
				line-height: 26px !important;
			}

			.value-desc {
				font-weight: 400;
				font-size: 18px !important;
				color: #a0a0a0;
				line-height: 26px !important;
			}
		}

		.section3-labels .row-label {
			font-size: 26px !important;
			line-height: 54px !important;
		}
	}

	.section3-design-title {
		margin-bottom: 34px;
	}

	.section3-body {
		display: flex;
		gap: 24px;
	}

	.section3-labels {
		width: 146px;
		padding-top: 0;
		display: grid;
		grid-template-rows: repeat(2, 1fr);
		gap: 14px;

		.row-label {
			display: flex;
			align-items: center;
			justify-content: center;
			font-size: 32px;
			line-height: 44px;
			color: #f0ad33;
			font-weight: 600;
			text-align: center;
		}
	}

	.section3-grid-wrap {
		flex: 1;
		display: flex;
		flex-direction: column;
		gap: 14px;
	}

	.section3-grid {
		display: grid;
		grid-template-columns: repeat(3, 1fr);
		gap: 14px;
	}

	.value-card {
		border: 1px solid #dedede;
		border-radius: 8px;
		padding: 24px 14px 14px;
		height: 359px;
		box-sizing: border-box;
		background: #fff;
	}

	.section3-grid-wrap > .section3-grid:last-child .value-card {
		padding: 58px 14px 14px;
	}

	.value-icon {
		width: 100px;
		height: 100px;
		display: block;
		margin: 0 auto 10px;
		transition: transform 0.35s ease;
		transform-origin: center center;

		&:hover {
			transform: scale(1.12);
		}
	}

	.value-title {
		text-align: center;
		font-size: 24px;
		line-height: 34px;
		font-weight: 600;
		color: #333333;
		margin-bottom: 14px;
		margin-top: 14px;
	}

	.value-desc {
		font-size: 16px;
		line-height: 24px;
		color: #a0a0a0;
	}
}

.join-section-wrap {
	width: 100%;
	margin: 0 auto;
	padding: 64px 0 180px;
	background: linear-gradient(0deg, #fffbf3, #ffffff);

	&.join-section-wrap--en {
		margin-bottom: 100px !important;
		padding-bottom: 240px;

		.section-design-title-text {
			font-size: 30px !important;
			line-height: 1.35 !important;
		}

		.join-step-title {
			font-size: 22px !important;
			line-height: 1.3 !important;
			width: 100%;
			max-width: 100%;
			box-sizing: border-box;
		}

		.join-step-desc {
			font-weight: 400;
			font-size: 18px !important;
			color: #333333;
			line-height: 26px !important;
		}

		.join-step {
			width: 250px;
		}

		.join-step--1 {
			bottom: -200px !important;
		}

		.join-step--2 {
			bottom: -220px;
		}

		.join-step--3 {
			bottom: -175px;
		}

		.join-step--4 {
			bottom: -164px !important;
		}
	}
}

.join-section {
	.join-flow {
		position: relative;
		width: 100%;
		min-height: 300px;
	}

	.join-center {
		position: absolute;
		left: 50%;
		bottom: 0;
		transform: translateX(-50%);
		z-index: 0;
		line-height: 0;
		pointer-events: none;

		img {
			display: block;
			width: 991px;
			height: auto;
			aspect-ratio: 991 / 297;
			object-fit: contain;
		}
	}

	.join-step {
		position: absolute;
		z-index: 1;
		width: 220px;
		display: flex;
		flex-direction: column;
		align-items: center;
		text-align: center;
		opacity: 0;
		transform: translateY(10px);
		backface-visibility: hidden;
		transition:
			opacity 0.58s cubic-bezier(0.33, 1, 0.68, 1),
			transform 1.05s cubic-bezier(0.16, 1, 0.3, 1);
	}

	.join-flow > .join-step:nth-child(2) {
		transition-delay: 0s;
	}

	.join-flow > .join-step:nth-child(3) {
		transition-delay: 0.14s;
	}

	.join-flow > .join-step:nth-child(4) {
		transition-delay: 0.28s;
	}

	.join-flow > .join-step:nth-child(5) {
		transition-delay: 0.42s;
	}

	@keyframes join-step-ball-float {
		0%,
		100% {
			transform: translateY(0);
		}
		50% {
			transform: translateY(-10px);
		}
	}

	.join-step-ball {
		display: block;
		width: 96px;
		height: 104px;
		margin: 0 auto 12px;
		object-fit: contain;
		transform: translateZ(0);
	}

	.join-flow > .join-step:nth-child(2).join-step--revealed .join-step-ball {
		animation: join-step-ball-float 2.4s ease-in-out infinite;
		animation-delay: 1.05s;
	}

	.join-flow > .join-step:nth-child(3).join-step--revealed .join-step-ball {
		animation: join-step-ball-float 2.4s ease-in-out infinite;
		animation-delay: 1.19s;
	}

	.join-flow > .join-step:nth-child(4).join-step--revealed .join-step-ball {
		animation: join-step-ball-float 2.4s ease-in-out infinite;
		animation-delay: 1.33s;
	}

	.join-flow > .join-step:nth-child(5).join-step--revealed .join-step-ball {
		animation: join-step-ball-float 2.4s ease-in-out infinite;
		animation-delay: 1.47s;
	}

	.join-step-title {
		font-size: 18px;
		font-weight: 600;
		color: #c67f34;
		margin: 0 0 8px;
		line-height: 26px;
		width: 100%;
		max-width: 100%;
		box-sizing: border-box;
		text-align: center;
	}

	.join-step-desc {
		margin: 0;
		width: 100%;
		max-width: 100%;
		box-sizing: border-box;
		font-size: 14px;
		line-height: 22px;
		color: #666666;
		text-align: center;
		white-space: pre-line;
	}

	.join-step--1 {
		left: 80px;
		bottom: -130px;
		transform: translateY(10px);
	}

	.join-step--1.join-step--revealed {
		opacity: 1;
		transform: translateY(0);
	}

	.join-step--2 {
		left: 40%;
		bottom: -140px;
		transform: translateX(-50%) translateY(10px);
	}

	.join-step--2.join-step--revealed {
		opacity: 1;
		transform: translateX(-50%) translateY(0);
	}

	.join-step--3 {
		left: 63%;
		bottom: -85px;
		transform: translateX(-50%) translateY(10px);
	}

	.join-step--3.join-step--revealed {
		opacity: 1;
		transform: translateX(-50%) translateY(0);
	}

	.join-step--4 {
		right: 60px;
		bottom: -30px;
		transform: translateY(10px);
	}

	.join-step--4.join-step--revealed {
		opacity: 1;
		transform: translateY(0);
	}

	@media (prefers-reduced-motion: reduce) {
		.join-flow > .join-step {
			transition: none !important;
			transition-delay: 0s !important;
			opacity: 1 !important;
		}

		.join-step--1,
		.join-step--4 {
			transform: none !important;
		}

		.join-step--2,
		.join-step--3 {
			transform: translateX(-50%) !important;
		}

		.join-flow > .join-step .join-step-ball {
			animation: none !important;
		}
	}
}

.section4-wrap {
	width: 100%;
	margin: 0 auto;
	min-height: 649px;
	padding: 72px 0 92px;
}

.section4 {
	&.section4--en {
		.section-design-title-text {
			font-size: 30px;
			line-height: 42px;
		}

		.section4-desc {
			font-weight: 400;
			font-size: 20px !important;
			color: #333333;
			line-height: 28px !important;
		}

		.section4-content {
			align-items: flex-start;
		}
	}

	.section4-design-title {
		margin-bottom: 96px;
	}

	.section4-content {
		display: flex;
		align-items: center;
		justify-content: space-between;
		gap: 40px;
	}

	.section4-desc {
		width: 320px;
		flex-shrink: 0;

		font-weight: 400;
		font-size: 20px;
		color: #333333;
		line-height: 28px;
	}

	.section4-phones {
		position: relative;
		flex: 1;
		min-width: 0;
		display: flex;
		justify-content: flex-end;
		align-items: flex-start;
		gap: 38px;
		min-height: 431px;
	}

	.section4-phone {
		width: 231px;
		height: 431px;
		display: block;
		object-fit: contain;
		flex-shrink: 0;
	}

	.section4-float {
		position: absolute;
		left: -56px;
		top: 207px;
		width: 262px;
		height: 113px;
		object-fit: contain;
		pointer-events: none;
	}
}

.section5-wrap {
	width: 100%;
	margin: 0 auto;
	height: auto;
	background: linear-gradient(0deg, #fffbf3, #ffffff);
	padding: 90px 0 86px;
}

.section5 {
	height: 100%;

	&.section5--en {
		.section5-title {
			font-size: 36px;
			line-height: 1.25;
		}

		.section5-desc {
			font-size: 20px !important;
			line-height: 28px !important;
		}

		.section5-left {
			width: 470px;
			max-width: 48%;
		}
	}
}

.section5-content {
	position: relative;
	overflow: hidden;
	width: 100%;
	height: auto;
	aspect-ratio: 1200 / 400;
	display: flex;
	align-items: center;
	padding-left: 62px;
}

.section5-left {
	position: relative;
	z-index: 3;
	width: 420px;
}

.section5-gradient-layer,
.section5-image-layer {
	position: absolute;
	inset: 0;
	background-size: 100% auto;
	background-repeat: no-repeat;
	background-position: center;
}

.section5-gradient-layer {
	z-index: 1;
}

.section5-image-layer {
	z-index: 2;
}

.section5-title {
	font-size: 42px;
	line-height: 58px;
	color: #333333;
	font-weight: 600;
	margin-bottom: 20px;
}

.section5-desc {
	font-size: 16px;
	line-height: 28px;
	color: #666666;
	margin-bottom: 28px;
	white-space: pre-line;
}

.section5-btn {
	display: inline-flex;
	align-items: center;
	justify-content: center;
	width: 232px;
	min-height: 48px;
	padding: 8px 18px;
	background: #333333;
	border-radius: 6px;
	box-sizing: border-box;
	font-size: 16px;
	line-height: 1.2;
	text-align: center;
	color: #ffffff;
	cursor: pointer;

	@include btn.dark-hover;
}

.service-institution-pc :deep(.category-btn:not(.is-active)) {
	@include btn.ghost-hover;
}

@media (max-width: 1100px) {
	.service-institution-pc[lang="en"] {
		.section4-content {
			gap: 24px;
		}

		.section4-desc {
			width: 280px;
		}

		.section4-phones {
			gap: 20px;
		}

		.section4-phone {
			width: clamp(180px, 20vw, 231px);
			height: auto;
			aspect-ratio: 231 / 431;
		}

		.section4-float {
			left: -36px;
			width: 220px;
			height: auto;
		}
	}
}
</style>
